const React = require("react");
const { Navigate, useParams } = require("react-router-dom");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { useDropshippingResource } = require("../hooks/useDropshippingResource");
const { PageHeader, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const PLATFORM_ACTIONS = {
  "cj-dropshipping": { to: "/dropshipping/cj/signup", key: "h_cj_signup_guide", label: "Signup guide" },
  printful: { to: "/dropshipping/printful", key: "h_pf_open", label: "Open Printful" },
  syncee: { to: "/dropshipping/syncee", key: "h_syncee_open", label: "Open Syncee" },
  printify: { to: "/dropshipping/printify", key: "h_printify_open", label: "Open Printify" },
  "inventory-source": { to: "/dropshipping/inventory-source", key: "h_inventorySource_open", label: "Open Inventory Source" },
};

const DropshippingPlatformDetails = () => {
  const { platformId } = useParams();
  const { api, t, isPlatformVisible } = useCJDropshipping();
  const resource = useDropshippingResource(() => api.getPlatform(platformId), [api, platformId]);
  const platform = resource.data?.platform;
  const platformAction = PLATFORM_ACTIONS[platform?.slug];
  if (platform && !isPlatformVisible(platform.slug)) {
    return h(Navigate, { to: "/dropshipping/platforms", replace: true });
  }
  return h(React.Fragment, null,
    h(PageHeader, { title: platform?.name || t("h_cj_platform_title", "Platform details"), action: h(LinkButton, { to: "/dropshipping/platforms", variant: "secondary" }, t("h_cj_back_platforms", "Back to platforms")) }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platform, onRetry: resource.reload, t },
      platform ? h("section", { className: "cjds-card" }, h("div", { className: "cjds-card-body" },
        h("div", { className: "cjds-row cjds-between" },
          h("h3", null, platform.name),
          h(StatusBadge, { status: platform.connection?.status || platform.status, t })
        ),
        h("p", { className: "cjds-muted" }, `${t("h_cj_auth_type", "Authentication")}: ${platform.authType}`),
        h("p", { className: "cjds-muted" }, `${t("h_cj_currencies", "Currencies")}: ${(platform.supportedCurrency || []).join(", ")}`),
        h("p", { className: "cjds-muted" }, platform.returnPolicy || t("h_cj_return_policy_empty", "No return policy has been configured.")),
        h("div", { className: "cjds-row" },
          platformAction ? h(LinkButton, { to: platformAction.to }, t(platformAction.key, platformAction.label)) : null,
          platform.slug === "cj-dropshipping" ? h(LinkButton, { to: "/dropshipping/connection", variant: "secondary" }, t("h_cj_api_connection", "API connection")) : null,
          platform.apiDocUrl ? h("a", { className: "cjds-btn secondary", href: platform.apiDocUrl, target: "_blank", rel: "noopener noreferrer" }, t("h_cj_api_docs", "API documentation")) : null
        )
      )) : null
    )
  );
};

module.exports = { DropshippingPlatformDetails };
